<div class="visao-geral panel-ctrl" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
    <div class="row linhavg1">
        <div class="pesquisa">
            <div class="offset-md-3 col-md-6 col-xs-3 offset-xs-3">
                <ul class="nav navbar-nav ml-auto">
                    <li class="nav-item">
                        <div class="form-group search-box has-feedback mb0 nav-link">
                            <div class="d-flex flex-wrap d-flex flex-wrap-row position-relative">
                                <input type="text" placeholder="{{'buyer.visao-geral.filtro' | translate}}" class="form-control" [(ngModel)]="searchTerm" maxlength="50" />

                                <i class="fa fa-search icon-search"></i>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            @if (userService.userRole() === 1) {
                <div class="menu-botoes col-md-3 text-end" [ngClass]="accountService.checkIfNotInIframe() ? 'd-none' : ''">
                    <ul class="nav navbar-nav ml-auto nav-invest">
                        <li class="nav-item dropdown">
                            <a href="javascript:void(0)" (click)="whatsApp_abrir()" class="chat name help nav-link">
                                <i class="fa fa-comments" aria-hidden="true" title="{{ 'elemento.topbar.atendimento.title' | translate }}"></i>
                                <span>{{ 'elemento.topbar.atendimento.label' | translate }}</span>
                            </a>
                        </li>
                        <li class="nav-item dropdown menunotification">
                            <a class="dropdown-toggle nav-link" href="javascript:void(0)" class="col-md-12 chat" data-toggle="dropdown" data-hover="dropdown" data-close-others="true" aria-expanded="false" [attr.disabled]="(notificationListUnreadMessages <= 0) ? 'disabled' : null">
                                <em class="fa fa-1x fa-bell-o popup"></em>
                                @if (notificationListUnreadMessages > 0) {
                                    <div class="badge label-danger">{{notificationListUnreadMessages > 9 ? "9+" : notificationListUnreadMessages}}</div>
                                }
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end list-group list-group-hover list-group-striped">
                                @for (notificacao of currentNotificationList; track notificacao) {
                                    <li class="notification-item dropdown-item">
                                        <a class="dropdown-item" data-toggle="modal" (click)="partsfyNotificationService.abrirNotificacoes(notificacao)">
                                            #{{notificacao?.order_id}} - {{ 'geral.notificacao.peca-cancelada.titulo' | translate }}
                                        </a>
                                    </li>
                                }
                            </ul>
                        </li>
                    </ul>
                </div>
            }
        </div>
    </div>
    <div class="row linhavg2">
        <div class="col-md-3 col-xs-3 colunavg">
            <span class="pipe-phase-arrow"></span>
            <div class="cabecalho">
                <div class="row">
                    <div class="col-md-12">
                        <h5><b>{{'buyer.visao-geral.colunas.titulos.aguardando-compra' | translate}}</b></h5>
                        <button type="button" class="btn btn-primary btn-sm">
                            {{(column01Quotations).length}} {{ ((column01Quotations).length > 1 ? 'buyer.visao-geral.colunas.cotacao-plural' : 'buyer.visao-geral.colunas.cotacao-singular') | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-xs-3 colunavg">
            <span class="pipe-phase-arrow"></span>
            <div class="cabecalho">
                <div class="row">
                    <div class="col-md-12">
                        <h5><b>{{'buyer.visao-geral.colunas.titulos.aguardando-confirmacao' | translate}}</b></h5>
                        <button type="button" class="btn btn-primary btn-sm">
                            {{(column02Quotations).length}} {{ ((column02Quotations).length > 1 ? 'buyer.visao-geral.colunas.pedido-plural' : 'buyer.visao-geral.colunas.pedido-singular') | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-xs-3 colunavg">
            <span class="pipe-phase-arrow"></span>
            <div class="cabecalho">
                <div class="row">
                    <div class="col-md-12">
                        <h5><b>{{'buyer.visao-geral.colunas.titulos.aguardando-entrega' | translate}}</b></h5>
                        <button type="button" class="btn btn-primary btn-sm">
                            {{(column03Quotations).length}} {{ ((column03Quotations).length > 1 ? 'buyer.visao-geral.colunas.pedido-plural' : 'buyer.visao-geral.colunas.pedido-singular') | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-xs-3">
            <div class="cabecalho historico">
                <div class="row">
                    <div class="col-md-12">
                        <h5><b>{{'buyer.visao-geral.colunas.titulos.ultimos-pedidos' | translate}}</b></h5>
                        <button type="button" class="btn btn-primary btn-sm">
                            {{(column04Quotations).length}} {{ ((column04Quotations).length > 1 ? 'buyer.visao-geral.colunas.pedido-plural' : 'buyer.visao-geral.colunas.pedido-singular') | translate}}
                        </button>
                        <button type="button" class="float-end btn7dias btn btn-light btn-sm" (click)="goToHistorico()">
                            <i class="fa-file-text-o fa" style="margin-right:2px"></i> {{'buyer.visao-geral.colunas.ultimos-pedidos.ver-historico' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row linhavg3">
        <div class="col-md-3 col-xs-3 {{ accountService.getCssInIframe() }} coluna">
            <div class="contentvgac">
                @if (userService.userRole() === 1) {
                    <div class="row btn-nova-cotacao">
                        <button class="btn btn-primary btn-lg vgbtn-nc" (click)="goToNovaCotacao()">
                            {{'buyer.visao-geral.colunas.aguardando-compra.botoes.criar-1' | translate}} <b>{{'buyer.visao-geral.colunas.aguardando-compra.botoes.criar-2' | translate}}</b>
                        </button>
                    </div>
                }

                @if ((column01Quotations).length == 0) {
                    <div class="text-center nenhum-encontrado {{ accountService.getCssInIframe() }} column-1">
                        <div>
                            <img alt="" src="../../../assets/imagens/etiqueta.png" height="156" width="156">
                            <p>{{'buyer.visao-geral.colunas.nenhuma-cotacao-encontrada' | translate}}</p>
                        </div>
                    </div>
                } @else {
                    <div class="contentvgac_cotacao {{ accountService.getCssInIframe() }}">
                        <ng-scrollbar class="cotacao {{ accountService.getCssInIframe() }}" [ngClass]="(userService.userRole() === 1) ? 'show-buy-button': ''" >
                            @for (cotacao of column01Quotations; track cotacao) {
                                <div class="listacotacoes">
                                    <ng-template #tipContent>
                                        <div class="dados-vendedor">
                                            <ul class="list-unstyled float-start">
                                                @for (comentario of cotacao.comentarios; track comentario) {
                                                    <li> <b>{{comentario.usuario.nome}} ({{comentario.data}}):</b> {{comentario.comentario.split("-")[1]}} </li>
                                                }
                                            </ul>
                                        </div>
                                    </ng-template>
                                    <ul class="list-unstyled">
                                        <li>
                                            <div class="cartao card card-primary">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-12 d-flex flex-wrap align-items-center general-infos">
                                                            <div title="{{cotacao.brand_name}}" class="float-start media-box-object rounded-circle marca {{cotacao.brand_name}}"></div>
                                                            <label class="truncate mb0">{{cotacao.vehicle}}</label>
                                                        </div>
                                                    </div>
                                                    <ul class="list-inline float-end">
                                                        <li class="text-muted-custom list-inline-item">
                                                            <div class="contadorReg">
                                                                <i class="fa fa-clock-o d-none"></i>
                                                                @if (userService.userRole() === 1 && (isUsuarioLocalPlanoPopular || cotacao.is_done_by_support)) {
                                                                    <div class="contador empty">
                                                                        <button type="button" class="btn btn-primary btn-sm btn1024 btnAddHoras mt-1" (click)="pedirAjuda(cotacao.transaction_id)">
                                                                            {{'buyer.visao-geral.colunas.aguardando-compra.botoes.pedir-ajuda' | translate}}
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="card-footer text-start painelBotoes">
                                                    <div class="icons float-start">
                                                        @if (userService.userHasCashback() && userService.userRole() < 3 && cotacao.has_cashback) {
                                                            <div class="text-muted-custom" tooltip="{{'buyer.visao-geral.colunas.aguardando-compra.botoes.cashback' | translate}}">
                                                                <b><i class="fa fa-usd"></i></b>
                                                            </div>
                                                        }
                                                        @if (cotacao.should_have_synced) {
                                                            <i-feather name="wifi-off" [tooltip]="'buyer.visao-geral.colunas.tooltip.should-have-synced.quotation' | translate: { erp: cotacao.erp }" [placement]="'right'"></i-feather>
                                                        }
                                                        <div>
                                                            @if (cotacao.has_cashback && userService.userRole() < 3) {
                                                                <span></span>
                                                            }
                                                        </div>
                                                    </div>
                                                    <ul class="list-inline float-end" style="padding-top: 1px;">
                                                        @if (this.userService.userIsCentral() && cotacao.comentarios.length > 0) {
                                                            <li class="text-muted-custom list-inline-item" [ngbTooltip]="tipContent" placement="top-left" container="body">
                                                                <b><i class="fa fa-comments"></i></b>
                                                            </li>
                                                        }
                                                        <li class="list-inline-item">
                                                            @if (userService.userRole() === 1) {
                                                                <em class="text-danger fa fa-trash excluir-cotacao" style="cursor: pointer" (click)="excluirCotacaoAbrirModal(cotacao.transaction_id)" tooltip="{{'buyer.visao-geral.colunas.aguardando-compra.botoes.excluir' | translate}}" placement="right"></em>
                                                            }
                                                        </li>
                                                        <li class="list-inline-item">
                                                            <button type="button" class="btn btn-light btn-sm comprar-cotacao" (click)="goToDetalhes(cotacao, 1)">
                                                                @if (cotacao.tem_resposta && userService.userRole() === 1) {
                                                                    {{ (userService.userPurchaseThroughApi() ? 'buyer.visao-geral.colunas.aguardando-compra.botoes.via-api' : 'buyer.visao-geral.colunas.aguardando-compra.botoes.comprar') | translate}}
                                                                }
                                                                @if (!cotacao.tem_resposta && cotacao.tem_vendedor && userService.userRole() === 1) {
                                                                    <b>+</b> {{'buyer.visao-geral.colunas.aguardando-compra.botoes.detalhes' | translate}}
                                                                }
                                                                @if (userService.userRole() > 1) {
                                                                    <b>+</b> {{'buyer.visao-geral.colunas.aguardando-compra.botoes.detalhes' | translate}}
                                                                }
                                                                @if (!cotacao.tem_vendedor && userService.userRole() === 1) {
                                                                    {{'buyer.visao-geral.colunas.aguardando-compra.botoes.distribuindo' | translate}}
                                                                }
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <ngx-loading [show]="cotacao.loading" [template]="templateCotacao"></ngx-loading>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            }
                        </ng-scrollbar>
                    </div>
                }
            </div>
        </div>

        <div class="col-md-3 col-xs-3 {{ accountService.getCssInIframe() }} coluna">
            <div class="contentvgac">
                @if ((column02Quotations).length == 0) {
                    <div class="text-center nenhum-encontrado {{ accountService.getCssInIframe() }}">
                        <div>
                            <img alt="" src="../../../assets/imagens/etiqueta.png" height="156" width="156">
                            <p>{{'buyer.visao-geral.colunas.nenhum-pedido-encontrado' | translate}}</p>
                        </div>
                    </div>
                } @else {
                    <div class="contentvgac_cotacao">
                        <ng-scrollbar class="pedido {{ accountService.getCssInIframe() }}">
                            @for (cotacao of column02Quotations; track cotacao) {
                                <div class="listacotacoes">
                                    <ul class="list-unstyled">
                                        <li>
                                            <div class="cartao card card-primary">
                                                <div class="card-body">
                                                    <div class="statuscard">
                                                        <label class="badge paddlab text-uppercase {{cotacao.classe}}"><i class="fa fa-calendar-o"></i> {{cotacao.status_entrega}}</label>
                                                    </div>
                                                    <div class="d-flex flex-wrap align-items-center general-infos" style="margin-bottom:6px;">
                                                        <div title="{{cotacao.brand_name}}" class="float-start media-box-object rounded-circle marca {{cotacao.brand_name}}"></div>
                                                        <label class="truncate mb0">{{cotacao.vehicle}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer text-start">
                                                    <button type="button" class="btn btn-light btn-sm btn-vgcomprar" data-toggle="modal" data-target="#aguardandoEntrega" (click)="goToDetalhes(cotacao, 2)">
                                                        <b>+</b> {{'buyer.visao-geral.colunas.aguardando-entrega.botoes.detalhes' | translate}}
                                                    </button>
                                                    <div class="icons float-end">
                                                        @if (cotacao.should_have_synced) {
                                                            <i-feather name="wifi-off" [tooltip]="'buyer.visao-geral.colunas.tooltip.should-have-synced.order' | translate: { erp: cotacao.erp }" [placement]="'left'"></i-feather>
                                                        }
                                                        @if (userService.userHasCashback() && userService.userRole() < 3 && cotacao.has_cashback) {
                                                            <div class="text-muted-custom" tooltip="{{'buyer.visao-geral.colunas.aguardando-compra.botoes.cashback-pedido' | translate}}">
                                                                <b><i class="fa fa-usd"></i></b>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            }
                        </ng-scrollbar>
                    </div>
                }
            </div>
        </div>

        <div class="col-md-3 col-xs-3 {{ accountService.getCssInIframe() }} coluna">
            <div class="contentvgac">
                @if ((column03Quotations).length == 0) {
                    <div class="text-center nenhum-encontrado {{ accountService.getCssInIframe() }}">
                        <div>
                            <img alt="" src="../../../assets/imagens/etiqueta.png" height="156" width="156">
                            <p>{{'buyer.visao-geral.colunas.nenhum-pedido-encontrado' | translate}}</p>
                        </div>
                    </div>
                } @else {
                    <div class="contentvgac_cotacao">
                        <ng-scrollbar class="pedido {{ accountService.getCssInIframe() }}">
                            @for (cotacao of column03Quotations; track cotacao) {
                                <div class="listacotacoes">
                                    <ul class="list-unstyled">
                                        <li>
                                            <div class="cartao card card-primary">
                                                <div class="card-body">
                                                    <div class="statuscard">
                                                        <label class="badge paddlab text-uppercase {{cotacao.classe}}"><i class="fa fa-calendar-o"></i> {{cotacao.status_entrega}}</label>
                                                    </div>
                                                    <div class="d-flex flex-wrap align-items-center general-infos" style="margin-bottom:6px;">
                                                        <div title="{{cotacao.brand_name}}" class="float-start media-box-object rounded-circle marca {{cotacao.brand_name}}"></div>
                                                        <label class="truncate mb0">{{cotacao.vehicle}}</label>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <small class="pecas-entregues">
                                                                {{'buyer.visao-geral.colunas.aguardando-entrega.entrega.aguardando_pecas' | translate}}
                                                                {{cotacao.total_bought_items - cotacao.total_delivered_items}}
                                                                {{((cotacao.total_bought_items - cotacao.total_delivered_items) <= 1 ? 'buyer.visao-geral.colunas.aguardando-entrega.entrega.peca-singular2' : 'buyer.visao-geral.colunas.aguardando-entrega.entrega.peca-plural2') | translate}}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer footer-aguardando-entrega">
                                                    <button type="button" class="btn btn-light btn-sm btn-vgcomprar" data-toggle="modal" data-target="#aguardandoEntrega" (click)="goToDetalhes(cotacao, 2)">
                                                        <b>+</b> {{'buyer.visao-geral.colunas.aguardando-entrega.botoes.detalhes' | translate}}
                                                    </button>
                                                    <div class="other-status-warning">
                                                        @if (cotacao.tem_devolucao) {
                                                            <span class="tem-devolucao text-danger">
                                                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ 'seller.dashboard.cards.tem-devolucao' | translate}}
                                                            </span>
                                                        }
                                                        @if (cotacao.tem_troca) {
                                                            <span class="tem-troca text-danger">
                                                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ 'seller.dashboard.cards.tem-troca' | translate}}
                                                            </span>
                                                        }
                                                    </div>
                                                    <div class="icons">
                                                        @if (cotacao.should_have_synced) {
                                                            <i-feather name="wifi-off" [tooltip]="'buyer.visao-geral.colunas.tooltip.should-have-synced.order' | translate: { erp: cotacao.erp }" [placement]="'left'"></i-feather>
                                                        }
                                                        @if (userService.userHasCashback() && userService.userRole() < 3 && cotacao.has_cashback) {
                                                            <div class="text-muted-custom" tooltip="{{'buyer.visao-geral.colunas.aguardando-compra.botoes.cashback-pedido' | translate}}">
                                                                <b><i class="fa fa-usd"></i></b>
                                                            </div>
                                                        }
                                                        <div>
                                                            @if (cotacao.has_cashback && userService.userRole() < 3) {
                                                                <span></span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            }
                        </ng-scrollbar>
                    </div>
                }
            </div>
        </div>

        <div class="col-md-3 col-xs-3 {{ accountService.getCssInIframe() }} coluna">
            <div class="contentvgac">
                @if ((column04Quotations).length == 0) {
                    <div class="text-center nenhum-encontrado {{ accountService.getCssInIframe() }}">
                        <div>
                            <img alt="" src="../../../assets/imagens/etiqueta.png" height="156" width="156">
                            <p>{{'buyer.visao-geral.colunas.nenhum-pedido-encontrado' | translate}}</p>
                        </div>
                    </div>
                } @else {
                    <div class="contentvgac_cotacao">
                        <ng-scrollbar class="pedido {{ accountService.getCssInIframe() }}">
                            @for (cotacao of column04Quotations; track cotacao) {
                                <div class="listacotacoes">
                                    <ul class="list-unstyled">
                                        <li>
                                            <div class="cartao card card-primary">
                                                <div class="card-body">
                                                    <div class="d-flex flex-wrap align-items-center general-infos">
                                                        <div title="{{cotacao.brand_name}}" class="float-start media-box-object rounded-circle marca {{cotacao.brand_name}}"></div>
                                                        <label class="truncate mb0">{{cotacao.vehicle}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer footer-aguardando-entrega">
                                                    <button type="button" class="btn btn-light btn-sm btn-vgcomprar" data-toggle="modal" data-target="#aguardandoEntrega" (click)="goToDetalhes(cotacao, 3)">
                                                        <b>+</b> {{'buyer.visao-geral.colunas.ultimos-pedidos.botoes.detalhes' | translate}}
                                                    </button>
                                                    <div class="other-status-warning">
                                                        @if (cotacao.tem_devolucao) {
                                                            <span class="tem-devolucao text-danger">
                                                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ 'seller.dashboard.cards.tem-devolucao' | translate}}
                                                            </span>
                                                        }
                                                        @if (cotacao.tem_troca) {
                                                            <span class="tem-troca text-danger">
                                                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ 'seller.dashboard.cards.tem-troca' | translate}}
                                                            </span>
                                                        }
                                                    </div>
                                                    <div class="icons">
                                                        @if (cotacao.should_have_synced) {
                                                            <i-feather name="wifi-off" [tooltip]="'buyer.visao-geral.colunas.tooltip.should-have-synced.order' | translate: { erp: cotacao.erp }" [placement]="'left'"></i-feather>
                                                        }
                                                        @if (userService.userHasCashback() && userService.userRole() < 3 && cotacao.has_cashback) {
                                                            <div class="text-muted-custom" tooltip="{{'buyer.visao-geral.colunas.aguardando-compra.botoes.cashback-pedido' | translate}}">
                                                                <b><i class="fa fa-usd"></i></b>
                                                            </div>
                                                        }
                                                        <div>
                                                            @if (cotacao.has_cashback && userService.userRole() < 3) {
                                                                <span></span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            }
                        </ng-scrollbar>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<ng-template #templateCotacao></ng-template>

<ng-template #templateEnviarConvite>
    <div class="modal-header">
        <div class="d-flex flex-column">
            <h4 class="modal-title">{{ 'buyer.cotacao.sidebar.excluir-cotacao.enviar-convite.titulo' | translate}}</h4>
            <span class="modal-subtitle">{{ 'buyer.cotacao.sidebar.excluir-cotacao.enviar-convite.subtitulo' | translate}}</span>
        </div>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="enviarConviteFecharModal();"></button>
    </div>
    <div class="modal-body modalscroll">
        <div class="row">
            <app-dados-convite #dadosConviteComponent [loading_local]="true" [notifier]="conviteNotifier"></app-dados-convite>
        </div>
    </div>
    <div class="modal-footer">
        <button id="closeModal" type="button" data-dismiss="modal" class="btn btn-light" (click)="enviarConviteFecharModal();">{{ 'buyer.cotacao.sidebar.excluir-cotacao.enviar-convite.botao.cancelar' | translate}}</button>
        <button id="btnSalvar" type="button" class="btn btn-primary" [disabled]="enviarConviteFormInvalid() ? 'disabled' : null" (click)="enviarConvite()">{{ 'buyer.cotacao.sidebar.excluir-cotacao.enviar-convite.botao.enviar' | translate}}</button>
    </div>
</ng-template>

<ng-template #templateExcluirCotacao>
    <div class="modal-header">
        <div class="d-flex flex-column">
            <h4 class="modal-title">{{ 'buyer.cotacao.sidebar.excluir-cotacao.titulo' | translate}}</h4>
            <span class="modal-subtitle">{{ 'buyer.cotacao.sidebar.excluir-cotacao.subtitulo' | translate}}<span class="dados-veiculo">{{vehicleCotacaoSelecionada}}</span></span>
        </div>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="excluirCotacaoFecharModal();"></button>
    </div>
    <div class="modal-body modalscroll">
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.cotacao.sidebar.excluir-cotacao.legenda' | translate}}</label>
                    <select name="reason" class="form-select m-b" [(ngModel)]="selected_reason" (change)="excluirCotacaoChangeValue()">
                        @for (reason of excluirCotacaoReasons; track reason) {
                            <option value="{{reason.id}}" [attr.needs-comment]="reason.needs_comment">{{reason.description}}</option>
                        }
                    </select>
                </div>
            </div>
        </div>
        <div class="row" style="height: 113px;">
            <div class="col-lg-12">
                <div class="mb-3 form-group">
                    <textarea name="comment" [(ngModel)]="comment" [disabled]="!excluirCotacaoNeedsComment" rows="4" placeholder="{{'elemento.generico-input.placeholder' | translate}}" class="form-control comment" required></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button customButton [outline]="true" [styleType]="'primary'" [isLoading]="false" [label]="'buyer.cotacao.sidebar.excluir-cotacao.botao.cancelar' | translate" (click)="excluirCotacaoFecharModal();"></button>
        <button customButton [styleType]="'primary'" [isLoading]="loading.removeQuotation" [label]="'buyer.cotacao.sidebar.excluir-cotacao.botao.excluir' | translate" (click)="excluirCotacao(0)"></button>
    </div>
</ng-template>

<dashboard-modal-avaliacao-component [avaliacoes]="avaliacoes" #modalAvaliacaoComponent></dashboard-modal-avaliacao-component>
